<template>
    <div class="messageBox">
        <div class="triangle_pageStateOne"
            :style="this.$store.getters.tabsIndex===0?'left:12%;':this.$store.getters.tabsIndex===1?'left:45%;':'left:80%;'" />
        <p class="dataLength">全部消息<span>{{NoticeListLength}}条</span></p>
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" :action="action" :isTags="true"
            @scroll="$Bus.$emit('IsSee',false);">
            <div class="items" v-for="item in NoticeList" @click="config[config.findIndex(e => e.id === item.State)].router
            && $router.push({ name: config[config.findIndex(e => e.id === item.State)].router, params: {item}})">
                <img
                    :src="config[config.findIndex(e => e.id === item.State)] && config[config.findIndex(e => e.id === item.State)].img">
                <div>
                    <p class="ellipsis">{{item.EquName}}</p>
                    <div>
                        <div>{{item.DepartmentName}}</div>
                    </div>
                    <p>{{item.OrderNo}}</p>
                </div>
                <div>
                    <div :style="{background: config[config.findIndex(e => e.id === item.State)] &&
                     config[config.findIndex(e => e.id === item.State)].color}">
                        {{config[config.findIndex(e => e.id === item.State)] && config[config.findIndex(e => e.id === item.State)].text}}
                    </div>
                    <p class="ellipsis">{{item.RepairDate}}</p>
                </div>
            </div>

        </LoadingFooter>
    </div>
</template>

<script>
    import {
        format
    } from '../../../tool/Date.js'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'MessageList',
        data() {
            return {
                tabsIndex: this.$store.getters.tabsIndex,
                //    是否正在上拉加载
                loading: true,
                //    是否没有更多数据了
                finished: false,
                //    数据
                NoticeList: [],
                page: 1, //页码
                NoticeListLength: 0, //总数量
                search: {},
            }
        },
        props: {
            State: String, //  每个标签页对应的state
            config: { //  每个标签页对应的配置
                type: Array,
                default: []
            },
            action: Boolean, //  当前tag是否聚焦
            startTime: String, //父组件传递
            endTime: String,
        },
        components: {
            LoadingFooter,
        },
        mounted() {
            this.loadAxios();
            this.$Bus.$on('hiddenEvent', (res) => {
                if (this.action) {
                    this.IsFirstSearch = false;
                    this.search = res;
                    this.NoticeList = [];
                    this.loadAxios();
                    this.page = 1;
                }
                return false;
            });
        },
        methods: {
            onLoad() { //上拉加载
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadAxios();
                }
            }, //  日历
            loadAxios() {
                this.loading = true;
                this.finished = false;
                this.$post('api/BlendQuery/NoticeList', { //请求方法
                    State: this.tabsIndex + 1,
                    UserCode: this.$UserInfo.UserId,
                    StoreId: this.$UserInfo.StoreCode,
                    PageIndex: this.page,
                    PageSize: 10,
                    Token: 'YTDF5EF3A6174564E5981A446158F106',
                    QueryCondition: this.search.inputValue,
                    Genre: this.search.state,
                    StartDate: this.startTime,
                    EndDate: this.endTime,
                    IsH5: 1,
                }).then(result => {
                    if (result.Status) {
                        this.NoticeListLength = result.Total;
                        for (let i = 0; i < result.NoticeList.length; i++) {
                            this.NoticeList.push(result.NoticeList[i]);
                        }
                        if (this.NoticeList.length < this.page * 10) {
                            this.loading = false;
                            this.finished = true;
                        } else this.loading = false;
                    } else {
                        this.$Toast(result.Msg);
                    }
                })
            }
        },
        watch: {
            $route(to, from) {
                if (to.name == "Message") { //替代activated钩子函数
                    this.page = 1;
                    this.NoticeList = [];
                    this.loadAxios();
                }
            },
            startTime(value) {
                this.page = 1;
                this.NoticeList = [];
                this.loadAxios();
            },
            endTime(value) {
                this.page = 1;
                this.NoticeList = [];
                this.loadAxios();
            }

        }
    }
</script>

<style scoped lang="scss">
    .messageBox {
        .triangle_pageStateOne {
            width: 0;
            height: 0;
            border-left: 30px solid transparent;
            border-right: 30px solid transparent;
            border-bottom: 22px solid $BACKGROUND-COLOR;
            position: relative;
            // left:10%;
            margin-top: 10px;
        }



        .dataLength {
            font-size: 28px;
            color: #4A4A4A;
            margin: 22vw 0 16px 30px;

            span {
                color: $THEME-COLOR;
                margin-left: 26px;
                font-weight: bold;
            }
        }

        .items {
            height: 202px;
            background: $BACKGROUND-COLOR;
            border-radius: 16px;
            display: flex;
            padding: 28px 26px 24px;
            box-sizing: border-box;
            margin-bottom: 20px;

            img {
                width: 48px;
                height: 48px;
            }

            &>div {
                &:nth-child(2) {
                    margin-left: 24px;
                    flex: 1;

                    p {
                        &:first-child {
                            color: $TEXT-DARK-COLOR;
                            font-size: 32px;
                            font-weight: bold;
                            width: 450px;
                        }

                        &:last-child {
                            font-size: 24px;
                            color: #4A4A4A;
                            margin-top: 14px;
                        }
                    }

                    &>div {
                        display: flex;
                        margin-top: 14px;

                        div {
                            min-width: 82px;
                            height: 42px;
                            background: #f3f3f3;
                            border-radius: 6px;
                            font-size: 22px;
                            color: #858585;
                            text-align: center;
                            line-height: 42px;
                            padding: 0 12px;
                            margin-right: 8px;
                        }
                    }
                }

                &:last-child {
                    div {
                        min-width: 86px;
                        height: 40px;
                        padding: 0 5px;
                        background: #FF9E48;
                        color: $TEXT-LIGHT-COLOR;
                        font-size: 22px;
                        text-align: center;
                        line-height: 40px;
                        border-radius: 0px 20px 20px 20px;
                        float: right;
                    }

                    p {
                        color: #A7A7A7;
                        font-size: 22px;
                        margin-top: 113px;
                        width: 132px;
                    }
                }
            }
        }
    }

    .CancelValue {
        position: relative;
        top: 3px;
        left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/messageList/messageList.vue